// import './css404.css'

const EmptyProject = () => {
    return(
        <div className='container d-flex flex-column align-items-center justify-content-center' style={{height: '100vh'}}>
            <h1 style={{color: "#13d3ec", fontSize:"40px"}}><b>No Calibrations Available</b></h1>
            <h4>It appears that there are currently no active calibrations available now.</h4>
            <div className="not-available-calibrations">
                <p style={{marginBottom: '0'}} className="white">Here are a few things you can do:</p>
                <ul>
                    <li style={{marginBottom: '0'}} className="white">Make sure you have the necessary permissions to access calibrations.</li>
                    <li style={{marginBottom: '0'}} className="white">If you expected to see calibrations here, please try refreshing the page or check back later as data may still be processing.</li>
                </ul>
                <p className="white">If you have any questions or need assistance, feel free to contact our support team for help.</p>
            </div>
        </div>
    )
}

export default EmptyProject